import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { IUser } from 'src/utils/Interfaces/user.interface'

const BASE_URL = import.meta.env.VITE_BASE_URL
const USER_URL = 'api/users'

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include'
  }),
  tagTypes: ['User'],
  endpoints: (build) => ({
    getUser: build.query<IUser, number>({
      query: (id) => ({
        url: `${USER_URL}/${id}`
      }),
      providesTags: ['User']
    }),
    getUsers: build.query<IUser[], void>({
      query: () => ({
        url: `${USER_URL}`
      }),
      providesTags: ['User']
    }),
    updateUser: build.mutation<IUser, Partial<IUser>>({
      query: (user) => ({
        url: `${USER_URL}`,
        method: 'PATCH',
        body: user
      }),
      invalidatesTags: ['User']
    })
  })
})

export const { useGetUserQuery, useGetUsersQuery, useUpdateUserMutation } = userApi
